import React, { useState, useEffect, useRef } from 'react'
import Bs from '@better-scroll/core'
import PullUp from '@better-scroll/pull-up';
import useDeepCompareEffect from 'use-deep-compare-effect'
import './index.scss'
Bs.use(PullUp)

/**
 * bsconfig ： 配置项
 *      scrollY: true,
        scrollX: false,
        click: true,
        probeType: 3,
        bounce: {
            top: false,
        },
        deceleration: 0.001,
        pullUpLoad: {
            threshold: -100  //当上拉距离超过50px时触发 pullingUp 事件
        }

* data : 数据依赖项目

* handlepullingUp 上拉执行方法
*/
const BScroll = (props) => {
    
    let { bsconfig, data,handlepullingUp,total } = props
    let [bscroll, setBscroll] = useState(null);
    let [moretxt,setmoretxt] = useState('加载更多...')
    const wrapper = useRef();

    useDeepCompareEffect(() => {
        // better-scroll
        const bscroll = new Bs(wrapper.current, {
            ...bsconfig,
        })
        setBscroll(bscroll)
        return () => {
            setBscroll(null);
        }
    }, [bsconfig])
    // 上拉加载
    useEffect(() => {
        if (!bscroll) return
        bscroll.on('pullingUp',async () => {
            await handlepullingUp()
            await bscroll.finishPullUp()
        } )
        return () => {
            setBscroll(null);
        }
    }, [bscroll,handlepullingUp])
    // 加载文本切换
    useDeepCompareEffect( () => {
        if( data.length >= total ){
            setmoretxt('加载完毕！')
        }
        return () => {
            setBscroll(null);
        }
    } ,[total,data])

    // 跟新better-scroll
    useDeepCompareEffect(() => {
        if (!bscroll) return
        bscroll.refresh();
    }, [data])
    return (
        <div className="scroll_main__box" ref={wrapper} style={{ height: '100%', position: 'relative' }}>
            <div>
                {props.children}
                <p className="load_more_text">{ data.length >= 10 ? moretxt : ''}</p>
            </div>
        </div>
    )
}
export default BScroll